module.exports = __webpack_public_path__ + "static/WEDDING E&M-609-d971bbadd624d19a516f6dfc87cbfb2d.jpg";